import { Component, OnInit, Input } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { IUser } from "src/app/interface/user";
import { CustomTranslatePipe } from "../../shared/custom-translate.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { RollBackComponent } from "../rollBack/rollBack.component";
import { TaskDurationComponent } from "../task-duration/task-duration.component";
import { RetroAdminComponent } from "../retro-admin/retro-admin.component";
import { NgIf } from "@angular/common";
import { AssetDefaultsComponent } from "../asset-defaults/asset-defaults.component";
import { MatTabsModule } from "@angular/material/tabs";

@Component({
    selector: "app-sms-set-defaults",
    templateUrl: "./set-defaults.component.html",
    styleUrls: ["./set-defaults.component.scss"],
    standalone: true,
    imports: [MatTabsModule, AssetDefaultsComponent, NgIf, RetroAdminComponent, TaskDurationComponent, RollBackComponent, TranslateModule, CustomTranslatePipe]
})
export class SetDefaultsComponent implements OnInit {
  @Input() FeatureTable: any;
  @Input() FeatureLayer: any;
  activeTab = 1;
  @Input() map: any;
  @Input() Graphic;
  @Input() Query: any;
  @Input() QueryTask: any;
  public currentUser: IUser;
  public jcc_functional: boolean = false;  // to hide not ready/not working functionality
  constructor(private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    this.activeTab = 1;
  }
}
